import { useEffect } from "react";

const useDisappearOnScrollDown = (el: string) => {
  // set opacity smoothly to 0 for discover-jumbomail-home on page scroll
  // when it starts to from center to bottom
  useEffect(() => {
    const discoverJumbomailHome = document.querySelector(el);
    const handleScroll = () => {
      if (discoverJumbomailHome) {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const discoverJumbomailHomeTop =
          discoverJumbomailHome.getBoundingClientRect().top;
        const discoverJumbomailHomeHeight = discoverJumbomailHome.clientHeight;
        const discoverJumbomailHomeBottom =
          discoverJumbomailHomeTop + discoverJumbomailHomeHeight;
        const discoverJumbomailHomeOpacity =
          (discoverJumbomailHomeBottom - scrollY) / windowHeight;
        (discoverJumbomailHome as HTMLDivElement).style.opacity =
          discoverJumbomailHomeOpacity.toString();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};

export default useDisappearOnScrollDown;
